export default Object.freeze({
  READ: 'read',
  EDIT: 'edit',
});
